/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FilterConditionDto } from './FilterConditionDto';

export type AssetFilterConditionDto = (FilterConditionDto & {
    assetUrns?: Array<string>;
    operator?: AssetFilterConditionDto.operator;
} & {
    assetUrns: Array<string>;
    operator: AssetFilterConditionDto.operator;
});

export namespace AssetFilterConditionDto {

    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
